<template>
  <div class="drawer-quantity__wrapper">
    <span style="margin-bottom: 20px;">Ajoutez votre quantité</span>
    <el-input-number
      :min="0"
      style="margin-bottom: 20px;"
      v-model="quantity"
      :step="1">
    </el-input-number>
    <div class="">
      <el-button
        style="margin-right: 10px;"
        type="danger"
        @click="hideQuantity">
        Annuler
      </el-button>
      <el-button
        style="margin-right: 10px;"
        type="success"
        @click="save">
        Enregistrer
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    defaultQuantity: { type: Number, default: 0 },
  },
  data() {
    return {
      quantity: this.defaultQuantity,
    };
  },
  methods: {
    showQuantity() {
      this.active = true;
    },
    hideQuantity() {
      this.$emit('onCancel');
    },
    save() {
      this.hideQuantity();
      this.$emit('onValueSaved', this.quantity);
    },
  },
};
</script>
<style lang="stylus" scoped>
.drawer-quantity__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
